import { PregledSihtaricaInterface } from "./PregledSihtarica.resources";

export const PregledSihtaricaResourceDE: PregledSihtaricaInterface = {
  title: "Arbeitszeitübersicht",
  accessDenied:
    "Kein Zugriff auf die Arbeitszeitübersicht. Diese Seite ist nur für Manager und Chefs verfügbar.",
  notLockedYet:
    "Keine genehmigten Einträge für diesen Zeitraum. PDF und Übersicht zeigen nur vom Manager genehmigte Einträge.",
  branch: "Filiale",
  branchPlaceholder: "Filiale auswählen",
  startDate: "Startdatum",
  endDate: "Enddatum",
  periodLabel: "Zeitraum (Monat)",
  statusOpen: "Keine genehmigten",
  statusLocked: "Hat genehmigte Einträge",
  viewByWorker: "Nach Mitarbeitern",
  viewByDay: "Nach Tagen",
  empty: "Keine Einträge für den ausgewählten Zeitraum.",
  totalHours: "Gesamt",
  colDate: "Datum",
  colWorker: "Mitarbeiter",
  colType: "Typ",
  colIn: "Beginn",
  colOut: "Ende",
  colHours: "Stunden",
  colNote: "Notiz",
  unapprove: "Genehmigung aufheben",
  unapproveOk: "Genehmigung wurde aufgehoben.",
  delete: "Löschen",
  deleteConfirm: "Möchten Sie diesen Eintrag wirklich löschen?",
  deleteOk: "Eintrag gelöscht.",
  cancel: "Abbrechen",
  actionError: "Aktion fehlgeschlagen.",
  pdf: {
    button: "PDF herunterladen",
    document: {
      name: "Name",
      title: "Arbeitszeiterfassung",
      odabraniPeriod: "Ausgewählter Zeitraum",
      ukupnoVrijeme: "Gesamtstunden",
      potpisFooter: "Unterschrift",
      upisaoFooter: "Genehmigt von",
      entryType: "Eintragstyp",
      napomena: "Notiz",
      pocetak: "Beginn",
      pocetakPauze: "Pausenbeginn",
      potpisano: "Unterschrieben",
      zavrsetak: "Ende",
      zavrsetakPauze: "Pausenende",
      tipovi: {
        DEZURA: "Bereitschaft",
        ODSUSTVO: "Abwesenheit",
        PRIPRAVNOST: "Rufbereitschaft",
        RADNOVRIJEME: "Arbeitszeit",
        RADUSMJENAMA: "Schichtarbeit",
        TERENSKIRAD: "Außeneinsatz",
        BOLOVANJE: "Krankenstand",
        SLOBODANDAN: "Freier Tag",
      },
    },
  },
};
